<template>
  <v-card class="my-3">
    <v-card-text>
      <v-col>
        <p class="subtitle-1">
          <v-icon left size="24">credit_card</v-icon>Пропуск ID: {{ card.number }}
        </p>
        <p>ФИО: {{ card.full_name }}</p>
        <p>
          Статус:
          <strong v-if="card.is_blocked || card.is_expired" class="red--text text--lighten-1">{{ card.is_blocked ? 'заблокирован' : 'истек срок'}}</strong>
          <strong v-else class="green--text text--lighten-1">активен</strong>
        </p>
        <p>Дата активации: <span>{{ card.started_at | date }}</span></p>
        <p>Действителен до: <span>{{ card.expired_at | date }}</span></p>
        <v-icon v-if="!noEdit" @click="$emit('card:edit')" class="card-edit-icon">edit</v-icon>
      </v-col>
      <slot name="actions"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CardInfoView',
  props: {
    card: {
      type: Object,
      required: true
    },
    noEdit: {
      type: Boolean,
      default: false
    }
  }
}
</script>